import { Directive, Input, TemplateRef, inject } from '@angular/core';
import { FaqTemplateContext } from 'src/models/faq.model';

@Directive({
  selector: '[liberroFaqItem]',
  standalone: false
})
export class LiberroFaqItemDirective {
  public templateRef = inject<TemplateRef<FaqTemplateContext>>(TemplateRef);

  @Input({ required: true }) public liberroFaqItem!: string | TemplateRef<void>; // title
  @Input() public active?: boolean;
  @Input() public faqId?: number;
  @Input() public highlight?: boolean;
  @Input() public preventBottomBorder?: boolean;
  @Input() public tooltipContent?: string;
}

